export const layoutWidth = "w-screen md:w-8/12";
export const secondaryTitle = "font-poppins text-textSecondary";
